import { Pill } from './SelectablePill.styles';
import type { SelectablePillProps } from './SelectablePill.types';

export function SelectablePill({ label, selected, onClick, disabled }: SelectablePillProps) {
  return (
    <Pill
      type="button"
      data-selected={selected}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
    >
      {label}
    </Pill>
  );
}
